module.exports = __webpack_public_path__ + "img/app0110.47b15522.png";